import store from "../index";
import { fetchGet } from "../api/fetch";
import { setLov } from "../actions/lov";

export const getLov = async (index) => {
  let currentLov = store.getState().lov;

  // Return the values from store if exists
  if (currentLov[index]) {
    return currentLov[index];
  }

  // Fetch the values
  try {
    if (!isNaN(index)) {
      let lov = await fetchGet(`attributes/${index}`);
      if (lov.values) {
        store.dispatch(setLov(index, lov.values));
        return lov.values;
      }
    } else {
      let lov;
      if (index === "tags") {
        lov = await fetchGet("tags");
      } else if (index === "riskLevel") {
        lov = await fetchGet("risk_levels");
      } else if (index === "status") {
        lov = await fetchGet("event_group_statuses");
      } else if (index === "eventGroupTypes") {
        lov = await fetchGet("event_group_types");
      } else if (index === "eventTypes") {
        lov = await fetchGet("event_types");
      } else if (index === "roles") {
        lov = await fetchGet("roles");
        lov = lov.filter((r) => r.active);
      } else if (index === "companyTypes") {
        lov = await fetchGet("company_types");
      } else if (index === "siteTypes") {
        lov = await fetchGet("site_types");
      } else if (index === "zoneTypes") {
        lov = await fetchGet("zone_types");
      } else if (index === "deviceTypes") {
        lov = await fetchGet("device_types");
      } else if (index === "profileTypes") {
        lov = await fetchGet("profile_types");
      } else if (index === "attributes") {
        lov = await fetchGet("attributes");
      } else if (index === "colors") {
        lov = await fetchGet("colors");
      } else if (index === "scheduleTypes") {
        lov = await fetchGet("schedule_types?active=true");
      }
      store.dispatch(setLov(index, lov));
      return lov;
    }
  } catch (e) {
    console.log(e);
  }
};

export const getOptionsFromLov = (lov, lovId, language) => {
  let options=
    lov[lovId]
      ? lov[lovId].map((v) => ({
          id: v.id,
          name: v["name_" + language],
        }))
      : [];
  return options;
};